import { OfferDocumentUrlConstant } from 'src/constants';
import {
  OfferDocumentDto,
  CreateOfferDocumentDto,
  GetOfferDocumentDto,
  PatchOfferDocumentDto,
  DeleteOfferDocumentDto,
  GetOfferDocumentListDto,
  UploadOfferDocumentDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class OfferDocumentsApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async create({ body }: CreateOfferDocumentDto): Promise<OfferDocumentDto> {
    return httpRequest<OfferDocumentDto>({
      method: 'POST',
      url: OfferDocumentUrlConstant.CREATE,
      body,
      authToken: this._configService.authToken,
    });
  }

  async list({ queryParams }: GetOfferDocumentListDto): Promise<OfferDocumentDto[]> {
    return httpRequest<OfferDocumentDto[]>({
      method: 'GET',
      url: OfferDocumentUrlConstant.LIST,
      queryParams,
      authToken: this._configService.authToken,
    });
  }

  async retrieve({ params }: GetOfferDocumentDto): Promise<OfferDocumentDto> {
    const url = replacePlaceholders(OfferDocumentUrlConstant.RETRIEVE, params);

    return httpRequest<OfferDocumentDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async patch({ params, body }: PatchOfferDocumentDto): Promise<OfferDocumentDto> {
    const url = replacePlaceholders(OfferDocumentUrlConstant.PATCH, params);

    return httpRequest<OfferDocumentDto>({
      method: 'PATCH',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async delete({ params }: DeleteOfferDocumentDto): Promise<void> {
    const url = replacePlaceholders(OfferDocumentUrlConstant.DELETE, params);

    await httpRequest<OfferDocumentDto>({
      method: 'DELETE',
      url,
      authToken: this._configService.authToken,
    });
  }

  async upload({ body }: UploadOfferDocumentDto): Promise<string> {
    const { rawFile } = body;

    await httpRequest<void>({
      method: 'PUT',
      url: body.url,
      headers: { contentType: rawFile.type },
      body: rawFile,
    });

    const [protocol, , , domain] = body.url.split('/');

    return `${protocol}//${domain}/${body.filepath}`;
  }
}
